import ListFnbProduct from './ListFnbProduct';

export default ListFnbProduct;
